import React from 'react';
import { Box, Button, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import useMobileMenu from '../../../../../hooks/useMobileMenu';
import { ProfileMobileDrawer } from './ProfileMobileDrawer';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { LogoWrapperB2B } from '../../../../shared/logos/LogoWrapperB2B';

const LogoWrapper = styled(Box)(({ theme }) => ({
    flex: 1,
    img: {
        maxWidth: '250px',
    },
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    boxShadow: '0 1px 3px #0000001a',
    padding: '0 15px',
}));

const DashboardContent = styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
}));

export const ProfileHeaderMobile = () => {
    const { t } = useTranslation();
    const mobileMenu = useMobileMenu();

    return (
        <>
            <HeaderContainer>
                <LogoWrapperB2B />
                {/*<LogoWrapper>*/}
                {/*    <img*/}
                {/*        src="/assets/MESTER_SZERELVENYOLT_logo_RGB.svg"*/}
                {/*        alt="mester-szerelvenybolt"*/}
                {/*    />*/}
                {/*</LogoWrapper>*/}
                <DashboardContent>
                    <Button>
                        <DehazeIcon
                            color={'primary'}
                            onClick={() => mobileMenu.showProfileMenu(true)}
                        />
                        {/*<AccountCircleOutlinedIcon*/}
                        {/*    color={'primary'}*/}
                        {/*    onClick={() => mobileMenu.showProfileMenu(true)}*/}
                        {/*/>*/}
                    </Button>
                </DashboardContent>
            </HeaderContainer>
            <ProfileMobileDrawer />
        </>
    );
};
